import type { GenerationType } from '@/api/types';

export interface Mode {
  kind: GenerationType;
  icon: string;          // lucide name
  label: string;
}

export const MODES: readonly Mode[] = [
  { kind: 'video', icon: 'Film',  label: 'Видео' },
  { kind: 'image', icon: 'Image', label: 'Картинка' },
] as const;
